import styled from 'styled-components';

import { PADDING_CONTENT_PAGE } from '../../../globals';


export const StyledBlockWrapper = styled.div`
  margin: 0px ${PADDING_CONTENT_PAGE}px 0px ${PADDING_CONTENT_PAGE}px;
  position: relative;
  ${props => props.setMinHeight ? 'min-height: ' + props.minHeight + 'px;' : ''}
}
`;



// WEBPACK FOOTER //
// ./src/common/DataWrapper/styles/StyledBlockWrapper.js